const countyConfigLanguagesReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDNOTIFICATION_COUNTY_CONFIG_LANGUAGES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigLanguagesReducer;